// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
export type WarnIfServerOverageFragment = {
  __typename?: "Organization";
  serverLimit?: number | null;
  serverCountForBilling: number;
  skipServerOverageWarning: boolean;
};

export const WarnIfServerOverageFragmentDoc = gql`
  fragment WarnIfServerOverage on Organization {
    serverLimit
    serverCountForBilling
    skipServerOverageWarning
  }
`;
